module.exports = __webpack_public_path__ + "img/pc-who-are-we-pic1.11474312.png";